import React, {useEffect, useRef} from 'react';
import {TextInput, View} from 'react-native';
import {TouchableOpacity} from 'react-native-gesture-handler';
import Icon from 'react-native-vector-icons/FontAwesome';

const SearchBar = ({
  onBlur,
  onFocus,
  containerStyle,
  inputStyle,
  onChangeText,
  placeholder,
  value,
  onClear,
  forceShowonClear = false,
}) => {
  const searchRef = useRef();
  useEffect(() => {
    if (!value && searchRef.current) {
      searchRef.current?.blur();
    }
    if (value?.length == 1) {
      setTimeout(() => {
        searchRef.current?.focus();
      }, 100);
    }
  }, [value]);
  return (
    <View
      style={{
        borderTopColor: '#e1e1e1',
        borderBottomColor: '#e1e1e1',
        backgroundColor: global.color.gray3,
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        position: 'relative',
        ...containerStyle,
      }}>
      <TextInput
        renderErrorMessage={false}
        onFocus={onFocus}
        onBlur={onBlur}
        onChangeText={onChangeText}
        placeholder={placeholder}
        value={value || ''}
        ref={searchRef}
        allowFontScaling={false}
        // @ts-ignore
        // ref={}
        style={{
          color: global?.color?.gray3,
          backgroundColor: 'white',
          marginLeft: 10,
          marginTop: 10,
          ...inputStyle,
        }}
      />
      <View
        style={{
          position: 'absolute',
          left: 20,
          top: 10,
          bottom: 0,
          // backgroundColor: 'blue',
          display: 'flex',
          justifyContent: 'center',
        }}>
        <TouchableOpacity>
          <Icon name={'search'} size={14} color={global?.color?.gray3} />
        </TouchableOpacity>
      </View>
      {!!(value || forceShowonClear) && (
        <View
          style={{
            position: 'absolute',
            right: 10,
            top: 10,
            bottom: 0,
            // backgroundColor: 'blue',
            display: 'flex',
            justifyContent: 'center',
          }}>
          <TouchableOpacity
            onPress={() => {
              if (onClear) {
                onClear();
              }
            }}
            style={{padding: 5}}>
            <Icon name={'times'} size={16} color={global?.color?.gray3} />
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};

export default SearchBar;
